import React, { Dispatch, ReactNode, createContext, useReducer } from 'react';

import * as types from './types';
type sparkyChipState = {
  isSparkyEnabled: boolean;
};
type sparkyChipAction = {
    payload: boolean; 
    type: string; 
};

const initialState: sparkyChipState = {
  isSparkyEnabled: false,
};

const sparkyChipReducer = (
  state: sparkyChipState,
  action: sparkyChipAction,
): sparkyChipState => {
  switch (action.type) {
    case types.SET_SPARKY_ENABLED:
      return {
        ...state,
        isSparkyEnabled: action.payload,
      };
    default:
      return initialState;
  }
};

type SparkyChipContextType = [sparkyChipState | null, Dispatch<sparkyChipAction>];

export const SparkyChipContext = createContext<SparkyChipContextType>([
  initialState,
  () => initialState,
]);

const SparkyChipProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [sparkyChipInfo, dispatchSparkyChipInfo] = useReducer(
    sparkyChipReducer,
    initialState,
  );

  return (
    <SparkyChipContext.Provider value={[sparkyChipInfo, dispatchSparkyChipInfo]}>
      {children}
    </SparkyChipContext.Provider>
  );
};

export default SparkyChipProvider;
